module.exports = __webpack_public_path__ + "img/hr-water-green4.580f0dc8.png";